import LaunchWizard from '@/pages/sender/launch-wizard';
import { senderRoutes } from '@/lib/sender-routes';
import { useNavigate } from 'react-router';

export default function SenderLaunchPage() {
	const navigate = useNavigate();

	function handleStarted(runId: string) {
		navigate(`${senderRoutes.run}${runId}`);
	}

	return <LaunchWizard onStarted={handleStarted} />;
}
